import React from 'react';
import { Link, useLocation, useParams } from "react-router-dom";

const Breadcrumb = (props) => {
    const location = useLocation();
    const params = useParams();

    // Split the pathname into segments, filtering out any empty ones
    const pathSegments = location.pathname.split('/').filter((segment) => segment);
    const classes = `breadcrumb text-capitalize fw-medium fs-sm${props.className ? ' ' + props.className : ''}`;

    return (
        <ol className={classes} style={{ '--bs-breadcrumb-divider': '"-"' }}>
            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
            {pathSegments.map((segment, index) => {
                // Check if the segment is a param key and use a default display if so
                const values = Object.values(params);
                const isParam = values.length > 0 && values.at(-1).includes(segment);
                const displayValue = isParam ? 'Detail' : segment;

                // Determine if the segment is the last one
                const isLastSegment = index === pathSegments.length - 1;

                return (
                    <li key={index} className={`breadcrumb-item${isLastSegment ? ' active' : ''}`}>
                        {isLastSegment ? (
                            displayValue
                        ) : (
                            <Link to={`/${pathSegments.slice(0, index + 1).join('/')}`}>
                                {displayValue}
                            </Link>
                        )}
                    </li>
                );
            })}
        </ol>
    );
};

export default React.memo(Breadcrumb);
